// 设备管理路由
// 权限 集控器模块：collector, 设备参数： device_parameters， 设备控制：device_control
const EquipmentMana = [
    // 集控器管理
    {
        path: '/gateway',
        component: resolve => require(['@/views/EquipmentMana/GatewayMana/GatewayMana'], resolve),
        name: 'gatewayMana',
        meta: { title: '集控器管理',  breadcrumb: [{ menu: 'gatewayMana' }], role: 'collector' },
    },
    // 添加表计
    {
        path: '/gateway/addmeter/:gatewayId',
        component: resolve => require(['@/views/EquipmentMana/GatewayMana/AddMeter/AddMeter'], resolve),
        name: 'addMeter',
        meta: { title: '添加表计', breadcrumb: [{ menu: 'gatewayMana', path: "/gateway" }, { menu: 'addMeter' }], role: 'collector' }
    },
    // 设备参数（添加风盘风柜）
    {
        path: '/fancoil-add',
        component: resolve => require(['@/views/EquipmentMana/EquipmentParameter/AddFanCoil'], resolve),
        name: 'plateMana',
        meta: { title: '设备参数', breadcrumb: [{ menu: 'plateMana' }], role: 'device_parameters' }
    },
    // 设备控制 计费系统
    {
        path: '/equipmentControl',
        component: resolve => require(['@/views/EquipmentMana/EquipmentControl/EquipmentControl'], resolve),
        name: 'equipmentControl',
        meta: { title: '设备状态', breadcrumb: [{ menu: 'equipmentControl' }], role: 'device_control' }
    },
    // 设备控制 控制系统
    {
        path: '/equipmentControl1',
        component: resolve => require(['@/views/EquipmentMana/EquipmentControl1/EquipmentControl1'], resolve),
        name: 'equipmentControl1',
        meta: { title: '设备控制', breadcrumb: [{ menu: 'equipmentControl' }], role: 'device_control' }
    },
    // 直连设备管理
    {
        path: '/directly',
        component: resolve => require(['@/views/EquipmentMana/DirectlyMana/DirectlyMana'], resolve),
        name: 'directlyMana',
        meta: { title: '直连设备管理',  breadcrumb: [{ menu: 'directlyMana' }], role: 'tDeviceManage' },
    },
    {
        path: '/EquipmentControl1/Info/:terminalid',
        component: resolve => require(['@/views/EquipmentMana/EquipmentControl1/EquipmentDetail'], resolve),
        name: 'eqInfo',
        meta: { title: '设备详情', breadcrumb: [{ menu: 'equipmentControl', path: '/equipmentControl1' }, { menu: 'equipmentControlInfo' }], role: 'device_control' }
    },
	{
	    path: '/EquipmentControl1/Info1/:terminalid',
	    component: resolve => require(['@/views/EquipmentMana/EquipmentControl1/EquipmentDetail1'], resolve),
	    name: 'eqInfo',
	    meta: { title: '设备详情', breadcrumb: [{ menu: 'equipmentControl', path: '/equipmentControl1' }, { menu: 'equipmentControlInfo' }], role: 'device_control' }
	},
    // 温控器实时读数
    {
        path: '/equipmentControl/wkqInfo/:terminalid',
        component: resolve => require(['@/views/EquipmentMana/EquipmentControl/EquimentInfoControl/EquimentWkqControl'], resolve),
        name: 'wkqInfo',
        meta: { title: '设备详情', breadcrumb: [{ menu: 'equipmentControl', path: '/equipmentControl' }, { menu: 'equipmentControlInfo' }], role: 'device_control' }
    },
    
    // 风柜实时读数
    {
        path: '/equipmentControl/fgInfo/:terminalid',
        component: resolve => require(['@/views/EquipmentMana/EquipmentControl/EquimentInfoControl/EquimentFgControl'], resolve),
        name: 'fgInfo',
        meta: { title: '设备详情', breadcrumb: [{ menu: 'equipmentControl', path: '/equipmentControl' }, { menu: 'equipmentControlInfo' }], role: 'device_control' }
    },
];

export default EquipmentMana